import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchDocs = ({ accessType, projectId, folderId, parentDocId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: accessType === 'personal' ? 'docs/personal' : 'docs',
        params: {
            project_id: projectId,
            folder_id: folderId,
            parent_doc_id: parentDocId,
            offset,
            limit
        }
    })
    .then(response => validateResponse(response, 'items').data)
    .catch(handleServerError);
}

export const createDoc = ({ accessType, project, parent_doc_id, type = 'nifty', subtype, name, content, googleAccessToken, googlePrivate = true, access_type, external_id, folder, folder_stack, order, template_id }) => {
    return AjaxService({
        method: 'post',
        url: accessType === 'personal' ? 'docs/personal' : 'docs',
        data: {
            project_id: project,
            parent_doc_id,
            type,
            subtype,
            name,
            content: content ? content : undefined,
            googleAccessToken,
            private: googleAccessToken && googlePrivate,
            access_type,
            external_id,
            folder_id: folder,
            folder_stack,
            order,
            template_id
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchDoc = (docId, preventError) => {
    return AjaxService({
        method: 'get',
        url: `docs/${docId}`
    })
    .then(response => response.data)
    .catch(!preventError && handleServerError);

}

export const updateDoc = (docId, { name, content, force, archived, folder, folder_stack, multipage, order, access_type }) => {
    return AjaxService({
        method: 'put',
        url: `docs/${docId}`,
        data: {
            name,
            content,
            force,
            archived,
            folder_id: folder,
            folder_stack,
            multipage,
            order,
            access_type
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeDoc = docId => {
    return AjaxService({
        method: 'delete',
        url: `docs/${docId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

/**
 * Adds members and update existing member permissions to doc
 * @param  {String} docId
 * @param  {Array} members Array<{ id: string, permission: string }>
 * @return {Promise}
 */
export const addDocMembers = (docId, members) => {
    return AjaxService({
        method: 'put',
        url: `docs/${docId}/members`,
        data: { members }
    })
    .then(response => response.data)
    .catch(handleServerError);

}

/**
 * Removes members from doc
 * @param  {String} docId
 * @param  {Array} members Array<id: string>
 * @return {Promise}
 */
export const removeDocMembers = (docId, members) => {
    return AjaxService({
        method: 'delete',
        url: `docs/${docId}/members`,
        data: { members }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const addDocLabels = (docId, labels, configOnly) => {
    const requestConfig = {
        method: 'put',
        url: `docs/${docId}/labels`,
        data: { labels }
    };

    if (configOnly) {
        return requestConfig;
    }

    return AjaxService(requestConfig)
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeDocLabels = (docId, labels, configOnly) => {
    const requestConfig = {
        method: 'delete',
        url: `docs/${docId}/labels`,
        data: { labels }
    };

    if (configOnly) {
        return requestConfig;
    }

    return AjaxService(requestConfig)
        .then(response => response.data)
        .catch(handleServerError);
}

export const getDocShareLink = docId => {
    return AjaxService({
        method: 'get',
        url: `docs/${docId}/share_url`
    }).then(response => {
        if (response.data.url) {
            return response.data.url.split('token=').pop();
        }

        return null;
    });
}

export const sendDocChanges = ({ id, changes_id, changes, member_id }) => {
    return AjaxService({
        method: 'post',
        url: `docs/${id}/change`,
        data: {
            changes_id,
            changes,
            member_id
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const generatePDF = ({ html, filename }) => {
    return AjaxService({
        method: 'post',
        url: `docs/pdf`,
        data: { html, filename }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const moveDoc = (docId, { project, folder, folder_stack }) => {
    return AjaxService({
        method: 'put',
        url: `docs/${docId}/move_to_project`,
        data: {
            project_id: project,
            folder_id: folder,
            folder_stack
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
